import { Link } from "react-router-dom";
import isologotipo from "../../assets/svgs/isologotipo.svg";
import { BoNotificationBell } from "./BoNotificationBell";
import { TenantSelector } from "./TenantSelector";

/**
 * Header — SYSTEM_DESIGN.md INC-07.
 *
 * Fijo (sticky), simplificado: logo GRUPS clickeable a Home y el selector
 * global de Tenant, con su label visible (§6.4 pide el label "Tenant", que
 * antes existía solo como placeholder del dropdown).
 *
 * Ya no lleva el botón hamburguesa: el sidebar es persistente y su control de
 * colapso vive en la parte superior del propio menú (§4.1).
 */
export const Header = () => (
  <header className="app-header flex justify-content-between align-items-center bg-primary py-4 px-2">
    <Link to="/" className="no-underline text-white flex align-items-center" aria-label="Inicio">
      <img src={isologotipo} alt="GRUPS" className="app-header__logo align-items-left" />
    </Link>

    <div className="flex align-items-center gap-2">
      {/* MT-012 — Selector de tenant (SUPER_ADMIN) / badge (TENANT_ADMIN). */}
      <label htmlFor="tenant-selector" className="text-white font-medium">
        Tenant
      </label>
      <TenantSelector />
      <BoNotificationBell />
    </div>
  </header>
);
